import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";

import { fetchUrl } from "../../../../functions/fetchUrl";

import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const PinApiPostedVibe = ({ table }) => {
  const today = new Date();

  useState("Loading...");

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [valueDateFrom, setValueDateFrom] = useState(today);
  const [valueDateTo, setValueDateTo] = useState(today);

  const [pinApiPosted, setpinApiPosted] = useState(0);

  // console.log(network)
  const columns = [
    {
      field: "networkname",
      headerName: "Network",
      width: 130,
    },
    {
      field: "cnt",
      headerName: "Network",
      width: 130,
    },
    {
      field: "operator",
      headerName: "Carrier",
      width: 130,
    },
  ];

  useEffect(() => {
    setData([])
  }, [table]);

  useEffect(() => {
    setData([]);
    const monthFromNumber = (valueDateFrom.getMonth() + 1).toString().padStart(2, "0");
    const dayFromNumber = valueDateFrom.getDate().toString().padStart(2, "0");
    const yearFromNumber = valueDateFrom.getFullYear();

    const monthToNumber = (valueDateTo.getMonth() + 1).toString().padStart(2, "0");
    const dayToNumber = valueDateTo.getDate().toString().padStart(2, "0");
    const yearToNumber = valueDateTo.getFullYear();

    const dateFrom = monthFromNumber + "-" + dayFromNumber + "-" + yearFromNumber;
    const dateTo = monthToNumber + "-" + dayToNumber + "-" + yearToNumber;

    const bodySend = {
      valueDate: dateFrom,
      valueToDate: dateTo,
    };

    const fetchData = async () => {
      setLoading(true);

      const response = await fetchUrl({
        method: "POST",
        apiName: table,
        reqBody: bodySend,
      });

      if (response.success) {

        const rows = response.result.map((item, index) => ({
          id: index + 1,   // guaranteed unique
          ...item
        }));

        setData(rows);
      }

      setLoading(false);
    };

    fetchData();
  }, [valueDateFrom, valueDateTo]);

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ display: "inline-block", margin: "0 10px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="From:"
              value={valueDateFrom}
              onChange={(newValue) => {
                setValueDateFrom(new Date(newValue));
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </div>
        <div style={{ display: "inline-block", margin: "0 10px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="To:"
              value={valueDateTo}
              onChange={(newValue) => {
                setValueDateTo(new Date(newValue));
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </div>
      </div>

      <DataGrid
        className="mt-2"
        rows={data}
        columns={columns}
        pageSize={15}
        rowsPerPageOptions={[5]}
        style={{ height: "60vh" }}
        getRowId={(data) => data.id}
        loading={loading}
      />
    </>
  );
};

export default PinApiPostedVibe;
